// Imports
import AxiosConfig from './serverAxiosConfig'
import firebase from '../config/FirebaseConfig'

// payload: { email }
const validateSignup = async (payload) => {
  const { data } = await AxiosConfig.post('/users/signup/validate', payload)
  return data
}

const getUserTeam = async () => {
  const { Aa: token } = firebase.auth().currentUser
  const { data } = await AxiosConfig.get('/users', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  return data?.team || null
}

const getBillingDetails = async () => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    '/users/billing',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

// Churn
const getChurnHash = async (cusId) => {
  const { Aa: token } = firebase.auth().currentUser

  const payload = {
    customerId: cusId
  }
  const { data } = await AxiosConfig.post(
    '/users/churn',
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const updateHubspotFields = async (fields) => {
  const { Aa: token } = firebase.auth().currentUser

  const payload = {
    fields
  }

  const { data } = await AxiosConfig.post(
    '/users/update-hubspot-fields',
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
  return data
}

const validateEmail = async () => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/users/queue-validate-email',
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const submitOnboardingPersonalization = async (payload) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/users/onboard-personalize-info',
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

// FB Auth for lens
const createFBToken = async (accessToken, redirectURI) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post('/users/auth-fb', {
    code: accessToken,
    redirect_uri: redirectURI
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  return data
}

const getSubscription = async (ignoreCache = false) => {
  const { Aa: token } = firebase.auth().currentUser

  const params = {}
  if (ignoreCache) {
    params.ignoreCache = ignoreCache
  }

  const { data } = await AxiosConfig.get('/users/subscriptions', {
    params,
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const getExpertUserByUTM = async (utm) => {
  const { data } = await AxiosConfig.get('/users/expert-profile', {
    params: { utm }
  })
  return data
}

const getForeplayExperts = async () => {
  const user = firebase.auth().currentUser
  if (!user) {
    throw new Error('User not authenticated')
  }

  const { data } = await AxiosConfig.get('/users/experts', {
    headers: {
      Authorization: `Bearer ${await user.getIdToken()}`
    }
  })
  return data
}
export default {
  validateSignup,
  getBillingDetails,
  getChurnHash,
  validateEmail,
  updateHubspotFields,
  getSubscription,
  createFBToken,
  submitOnboardingPersonalization,
  getUserTeam,
  getExpertUserByUTM,
  getForeplayExperts
}
